import moment from "moment";
enum Sens {
    D = "D",
    C = "C",
}

type Ecriture = {
    periode: string;
    compte: string;
    libelle: string;
    sens: Sens;
    indexRepartition: number;
    valeur: number;
    pctRepartition: number;
};
type SilaeJson = {
    numeroDossier: string;
    periodeDebut: string;
    periodeFin: string;
    ecritures: Ecriture[];
};
type SilaeUser = {
    reponsesInfosPaie: { champ: string; valeur: string }[];
};

type User = {
    key: string;
    firstname: string;
    lastname: string;
};

type AccountingLine = {
    date: string;
    accountableAccount: string;
    wording: string;
    amountSigned: number;
    debit: number;
    credit: number;
    user: User;
};

export class ImportSilae {
    // json: SilaeJson;
    // aaCharacterCount: number;
    // users: { [key: string] : SilaeUser; } = null;

    constructor(
        public json: SilaeJson,
        private aaCharacterCount: number,
        private users: { [key: string]: SilaeUser } = null
    ) {
        // this.json = json;
        // this.aaCharacterCount = aaCharacterCount;
    }

    static getAccountingTransactions(
        silaeJsons: SilaeJson[],
        users: { [key: string]: SilaeUser },
        aaCharacterCount: number
    ) {
        const accountingTransactions = [];
        for (const silaeJson of silaeJsons) {
            const importSilae = new ImportSilae(silaeJson, aaCharacterCount, users);
            if (!importSilae.isSilae) {
                throw new Error("Wrong format");
            }
            const rows = importSilae.accountingLines;
            accountingTransactions.push({
                type: "PAY_SLIP",
                wording: importSilae.title,
                date: importSilae.date,
                rows,
            });
        }
        return accountingTransactions;
    }

    get isSilae() {
        if (!this.json) {
            return false;
        }
        if (!this.json.numeroDossier) {
            return false;
        }
        if (!this.json.periodeDebut) {
            return false;
        }
        if (!this.json.periodeFin) {
            return false;
        }
        if (!this.json.ecritures?.length) {
            return false;
        }
        for (const ecriture of this.json.ecritures) {
            if (!ecriture.periode) {
                return false;
            }
            if (!ecriture.compte) {
                return false;
            }
            if (!ecriture.libelle) {
                return false;
            }
            if (!ecriture.sens) {
                return false;
            }
            if (!ecriture.valeur) {
                return false;
            }
        }
        return true;
    }

    get title() {
        return (
            this.json.numeroDossier +
            " - du " +
            moment(this.json.periodeDebut).format("DD/MM/YYYY") +
            " au " +
            moment(this.json.periodeFin).format("DD/MM/YYYY")
        );
    }

    get date() {
        if (this.json?.ecritures?.length) {
            return this.json.ecritures[0].periode;
        }
        console.error("ImportSilae missing ecritures");
        debugger;
        return null;
    }

    get accountingLines() {
        // "periode": "2024-10-01T00:00:00",
        // "compte": "64111",
        // "libelle": "Salaires, appointements - 00011 - BENEDETTI LUC",
        // "sens": "D",
        // "indexRepartition": 0,
        // "valeur": 2068.0,
        // "pctRepartition": 0.0
        const accountingLines: AccountingLine[] = [];
        for (const ecriture of this.json.ecritures) {
            let user: User;
            if (ecriture.compte.startsWith("421")) {
                user = ImportSilae.identifyUser(ecriture.libelle, this.users);
            }
            accountingLines.push({
                date: ecriture.periode,
                accountableAccount: ecriture.compte.padEnd(this.aaCharacterCount, "0"),
                wording: ecriture.libelle,
                debit: ecriture.sens === Sens.D ? ecriture.valeur : 0,
                credit: ecriture.sens === Sens.C ? ecriture.valeur : 0,
                amountSigned: ecriture.sens === Sens.D ? ecriture.valeur : -ecriture.valeur,
                user,
            });
        }
        return accountingLines;
    }

    // get separator() {
    //     return "    ";
    // }
    // //
    // // to fit importFec Base => compute firstLine, formatResult,
    // //
    // get firstLine() {
    //     return `date${this.separator}accountableAccount${this.separator}wording${this.separator}debit${this.separator}credit${this.separator}userKey${this.separator}firstname${this.separator}lastname`;
    // }

    // get lines(): string {
    //     let lines = "";
    //     for (const al of this.accountingLines) {
    //         lines += al.date;
    //         lines += this.separator;
    //         lines += al.accountableAccount;
    //         lines += this.separator;
    //         lines += al.wording;
    //         lines += this.separator;
    //         lines += al.debit;
    //         lines += this.separator;
    //         lines += al.credit;
    //         lines += this.separator;
    //         lines += al.user?.key || "";
    //         lines += this.separator;
    //         lines += al.user?.firstname || "";
    //         lines += this.separator;
    //         lines += al.user?.lastname || "";
    //         lines += this.separator;
    //         lines += "\n";
    //     }

    //     return lines;
    // }

    get importFecData() {
        const data = [];
        for (const al of this.accountingLines) {
            // let CompteLib;
            // const aa = accountableAccountTable.accountableAccounts.find(
            //     (aa) => aa.name === al.accountableAccount
            // );
            // if (aa?.description) {
            //     CompteLib = aa.description;
            // }
            data.push({
                JournalCode: "SILAE",
                JournalLib: "Silae",
                EcritureNum: 1,
                EcritureDate: moment(al.date).format("YYYYMMDD"),
                CompteNum: al.accountableAccount,
                // CompteLib,
                EcritureLib: al.wording,
                userKey: al.user?.key,
                firstname: al.user?.firstname,
                lastname: al.user?.lastname,
                Debit: al.debit.toString(),
                Credit: al.credit.toString(),
            });
        }
        return data;
    }

    static identifyUser(wording, users: { [key: string]: SilaeUser } = null): User {
        let user: User;
        if (wording) {
            const result = wording.match(/- ([^-]{1,}) - ([^-]{1,})$/);
            if (result?.length === 3) {
                // extract both  firstname and lastname
                let firstname = "";
                let lastname = result[2];
                const silaeUser = users?.[result[1]];
                let found: number = 0;
                if (silaeUser) {
                    const prenom = silaeUser.reponsesInfosPaie?.find(
                        (rip) => rip.champ === "INT_Prenom"
                    );
                    if (prenom) {
                        firstname = prenom.valeur;
                        found++;
                    }
                    const nom = silaeUser.reponsesInfosPaie?.find(
                        (rip) => rip.champ === "INT_NomUsuel"
                    );
                    if (nom) {
                        lastname = nom.valeur;
                        found++;
                    }
                }
                if (found !== 2) {
                    const fnln = result[2].match(/([A-Z ]{1,})([A-Z][a-zéèïàçù]{1,})/);
                    if (fnln?.length === 3) {
                        firstname = fnln[2];
                        lastname = fnln[1];
                    }
                }
                user = {
                    key: result[1],
                    firstname,
                    lastname,
                };
            } else {
                debugger;
            }
        }
        return user;
    }
}
